<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.3524 11.6475L18.3524 7.64753C18.0384 7.33354 17.5016 7.55592 17.5016 7.99997V11H2C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H17.5016V16C17.5016 16.444 18.0384 16.6664 18.3524 16.3524L22.3524 12.3524C22.5471 12.1578 22.5471 11.8422 22.3524 11.6475Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ArrowIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
